import React, { Component } from 'react';

import Bio from '../category/Bio';
import CollectionTitle from './common/collection-title';
import ProductListing from './common/product-listing';
import LocationRequiredOverlay from '../category/LocationRequiredOverlay';

class Collection extends Component {
	constructor(props) {
		super(props);
		this.state = {
			showAddressModal: props.locationRequired ? props.locationRequired : false,
			forceUpdate: false,
		};
	}

	onOpenModal() {
		this.setState({ showAddressModal: true });
	}

	onCloseModal() {
		this.setState({ showAddressModal: false });
	}

	getBio(products) {
		var bio = null;
		for (var i = 0; i < products.length; ++i) {
			bio = products[i].selectedProviderService ? products[i].selectedProviderService.providerId : null;

			if (bio) {
				break;
			}
		}

		return (
			bio &&
			bio.ShowBio && (
				<Bio showFitmentDisclaimer={true} imageUrl={bio.DriverImageUrl} name={bio.Name} quote={bio.DriverBio} />
			)
		);
	}

	componentDidMount() {
		let _this = this;
		if (this.props.geolocation) {
			if (this.props.geolocation.isGeoLocationAvailable && !this.props.geolocation.isGeoLocationEnabled) {
				this.setState({ showAddressModal: true });
			}
		}

		// FIXME: Hack for forcing re-render.
		setTimeout(function () {
			_this.setState({
				forceUpdate: !_this.state.forceUpdate,
			});
		}, 0);
	}

	render() {
		const {
			products,
			label,
			applicationSlug,
			provider,
			geolocation,
			locationRequired,
			imageUrl,
			isUpdating,
			isFeatured,
			externalrequest,
			reviews,
		} = this.props;
		var first_name = null;

		if (externalrequest) {
			first_name = this.props.externalrequest.request
				? this.props.externalrequest.request.address.firstName
				: this.customer
				? this.customer.first_name
				: null;
		}
		return (
			<div className="collection-wrapper">
				<div className="container">
					<div className="row">
						<div className="collection-content col">
							<div className="page-main-content">
									{!isFeatured ? (
										<CollectionTitle
												isAvailable={this.props.productServices.length >= 1}
												locationRequired={locationRequired}
												label={label}
												geolocation={geolocation}
												imageUrl={imageUrl}
												isUpdating={isUpdating}
												first_name={first_name}
											/>
										) : (
											''
										)}

										<div className="collection-product-wrapper">
											{locationRequired && <LocationRequiredOverlay />}
											<ProductListing
												productList={products}
												applicationSlug={applicationSlug}
												applicationLabel={label}
												provider={provider}
												setSelectedProvider={this.props.setSelectedProvider}
												showBuyButton={this.props.showBuyButton}
												isUpdating={this.props.isUpdating}
												productServices={this.props.productServices}
												masterProvider={this.props.masterProvider}
												externalrequest={this.props.externalrequest}
												reviews={reviews}
											/>
										</div>

									{products && this.getBio(products)}
							</div>
						</div>
					</div>
				</div>
			</div>
		);
	}
}

export default Collection;
